<mat-card>
    <section>
        <p class="title">
            <strong>OPS!</strong> <br> NÃO ENCONTRAMOS ESSA PÁGINA!
        </p>
        <p class="error">
            404
        </p>
    </section>
    <mat-card-actions class="actions">
        <button mat-button [routerLink]="['']">Voltar para o início</button>
    </mat-card-actions>
</mat-card>
